// Turks (tr-TR), homeApp: zelfde vorm als homeApp.nl.ts (golf 6b). Warme sen-vorm zoals app.tr.ts;
// na een {naam} geen achtervoegsel (klinkerharmonie onbekend): de naam als onderwerp of met ":".
// Het weerdetail noemt nooit namaz of cami (neutraal).
export const appHomeTr = {
    customize: 'Düzenle',
    customizeLabel: 'Bugün ekranını düzenle',
    done: 'Tamam',
    intro: 'Bugün ekranına senin için önemli olanı koy. Bir kartı başka bir yere sürükle, kenarından veya köşesinden büyüt ya da küçült, ya da S, M veya L seç.',
    /** Telefoon: alleen de volgorde (feat/vandaag-raster). */
    introList: 'Kartları istediğin sıraya koy: tutamaçtan sürükle veya okları kullan. Daha büyük bir ekranda onları serbestçe yerleştirip büyütebilir veya küçültebilirsin.',
    undo: 'Geri al',
    undone: 'Son değişiklik geri alındı.',
    /** Raster (computer en tablet): zoals de bord-editor. */
    gridHint: 'Bugün ızgarası: bir kartı başka bir yere sürükle, küçültmek veya büyütmek için kenarından ya da köşesinden çek.',
    cardAt: '{name}, {w} x {h} kare, sütun {x}, satır {y}',
    keysHint: 'Ok tuşları: taşı. Shift ve ok tuşları: küçült veya büyüt.',
    noRoom: 'Buraya sığmıyor. Önce bir şeyi küçült veya kaldır.',
    size: 'Boyut',
    sizes: { S: 'Küçük', M: 'Orta', L: 'Büyük' },
    fitMore: '+{count} tane daha',
    fitMoreAll: 'Daha fazlasını gör',
    reset: 'Varsayılana döndür',
    resetDone: 'Bugün ekranı eski hâline döndü.',
    saveFailed: 'Kaydedilemedi. Birazdan tekrar dene.',
    add: 'Kart ekle',
    addTitle: 'Kart ekle',
    addNothing: 'Tüm kartlar zaten ekranda.',
    moveUp: '{name}: yukarı taşı',
    moveDown: '{name}: aşağı taşı',
    remove: '{name}: kaldır',
    removed: '{name} kaldırıldı.',
    added: '{name} artık Bugün ekranında.',
    drag: '{name}: sürükle',
    position: '{name} artık {count} yerden {pos}. sırada.',
    empty: 'Bugün ekranı henüz boş.',
    emptyBody: 'Düzenle’ye dokun ve burada ne görmek istediğini seç.',
    emptyEdit: 'Henüz kart yok. Aşağıdan bir tane ekle.',
    quiet: 'Şu an gösterilecek bir şey yok. Bir şey olunca kart kendiliğinden görünür.',
    widgets: {
        now: { name: 'Şu an', description: 'Şu an olan ya da birazdan başlayan' },
        agenda: { name: 'Bugünün takvimi', description: 'Bugünün tüm etkinlikleri' },
        tasks: { name: 'Bugünün görevleri', description: 'Herkes görevlerinde ne durumda' },
        tomorrow: { name: 'Yarın', description: 'Yarınki etkinliklere bir bakış' },
        weather: { name: 'Hava', description: 'Hava ve giyim önerisi, fazlası için dokun' },
        rides: { name: 'Ulaşım', description: 'Henüz kimsenin götürmediği yolculuklar' },
        prayer: { name: 'Namaz vakitleri', description: 'Bugünün vakitleri' },
        check_in: { name: 'Günlük kontrol', description: "Bugün 'Her şey yolunda' geldi mi" },
        goals: { name: 'Biriktirme', description: 'Çocuklar biriktirmede ne durumda' },
        shopping: { name: 'Alışveriş', description: 'Daha alınması gerekenler' },
        messages: { name: 'Mesajlar', description: 'Aileden yeni mesajlar' },
        wishes: { name: 'Dilekler', description: 'Çocukların dilekleri' },
        rotation: {
            name: 'Nöbet çizelgesi',
            description: 'Bu hafta kim ne yapıyor ve bugün kim yemek yapıyor',
        },
        // Golf 8 (0049): Samen wonen.
        dinner: { name: 'Bu akşam yemek', description: 'Kimler yiyor ve senin seçimin' },
        bookings: { name: 'Rezervasyon', description: 'Sıradaki rezervasyonun ve boş olanlar' },
        balance: { name: 'Masraflar', description: 'Yalnızca kendi bakiyen' },
        // 0069: Geldzaken (alleen in je eigen omgeving).
        money: { name: 'Para işleri', description: 'Bu ay ne kaldı (yalnızca sen)' },
        todos: { name: 'Yapılacaklar', description: 'Açık yapılacakların, son tarihiyle' },
        // 0076: schoolplanner.
        school: {
            name: 'Ödev ve sınavlar',
            description: 'Bugünün ödevleri, yaklaşan sınavlar ve girilecek notlar',
        },
        // 0075: Huisronde (module Eten).
        house_round: { name: 'Ev turu', description: 'Evdeki bir sonraki tur ve başlatma' },
    },
    shopping: {
        open: { one: 'Alınacak {count} şey', other: 'Alınacak {count} şey' },
        empty: 'Her şey alındı.',
        all: 'Alışverişe git',
        more: '+{count} tane daha',
    },
    messages: {
        unread: { one: '{count} yeni mesaj', other: '{count} yeni mesaj' },
        none: 'Yeni mesaj yok.',
        all: 'Mesajlara git',
        voice: 'Sesli mesaj',
        sticker: 'Çıkartma',
        pictos: 'Resimler',
    },
    wishes: {
        count: { one: '{count} dilek', other: '{count} dilek' },
        empty: 'Henüz dilek yok.',
        all: 'Dileklere git',
    },
    /** Golf 6b fixer r1: widget Beurtrooster (huisgenoten). */
    rotation: {
        you: 'Bu hafta sen',
        done: 'Yapıldı',
        open: 'Henüz yapılmadı',
        noneForYou: 'Bu hafta senin sıran yok.',
        cooks: 'Bugün {name} yemek yapıyor',
        youCook: 'Bugün sen yemek yapıyorsun',
        others: 'Evin geri kalanı',
        all: 'Çizelgeye git',
        empty: 'Henüz nöbet çizelgesi yok.',
    },
    prayer: {
        next: 'Sıradaki',
        settings: 'Ayarlar',
        fromTable: 'Caminin takviminden',
    },
};
export const appAgendaViewsTr = {
    day: 'Gün',
    workweek: 'İş haftası',
    week: 'Hafta',
    month: 'Ay',
    workweekTitle: 'İş haftası {week} · {range}',
    emptyWorkweek: 'Bu iş haftası için henüz bir şey planlanmadı',
    prev: {
        day: 'Önceki gün',
        workweek: 'Önceki iş haftası',
        week: 'Önceki hafta',
        month: 'Önceki ay',
    },
    next: {
        day: 'Sonraki gün',
        workweek: 'Sonraki iş haftası',
        week: 'Sonraki hafta',
        month: 'Sonraki ay',
    },
    keys: 'Kısayollar: gezinmek için ← ve →, bugün için T.',
};
export const appWeatherDetailTr = {
    open: 'Hava hakkında daha fazlası',
    titleToday: 'Bugün hava',
    titleTomorrow: 'Yarın hava',
    today: 'Bugün',
    tomorrow: 'Yarın',
    temp: 'Sıcaklık',
    tempRange: '{min}° ile {max}° arası',
    feels: 'Hissedilen sıcaklık',
    feelsRange: '{min}° ile {max}° arası',
    feelsDay: 'gündüz yaklaşık {value}°',
    rain: 'Yağmur',
    rainChance: {
        dry: 'Kuru',
        small: 'Sağanak ihtimali düşük',
        likely: 'Yağmur ihtimali var',
        wet: 'Yağmurlu',
    },
    rainAmount: '{mm} mm',
    rainHours: { one: '{count} saatte', other: '{count} saatte' },
    rainWhen: '{from} ile {until} arası',
    rainPct: '%{pct} ihtimal',
    rainNoPct: 'MET Norway Hollanda için yüzde olarak ihtimal vermiyor. Bu, tahmine göre düşecek yağış miktarı.',
    wind: 'Rüzgâr',
    windForce: 'Rüzgâr kuvveti {bft}',
    windFrom: 'yönü: {dir}',
    windSpeed: '{kmh} km/sa',
    bft: [
        'durgun',
        'esinti',
        'hafif rüzgâr',
        'hafif rüzgâr',
        'orta rüzgâr',
        'sert rüzgâr',
        'kuvvetli rüzgâr',
        'fırtınamsı rüzgâr',
        'fırtına',
        'kuvvetli fırtına',
        'tam fırtına',
        'çok şiddetli fırtına',
        'kasırga',
    ],
    dirs: {
        N: 'kuzey',
        NE: 'kuzeydoğu',
        E: 'doğu',
        SE: 'güneydoğu',
        S: 'güney',
        SW: 'güneybatı',
        W: 'batı',
        NW: 'kuzeybatı',
    },
    dirShort: { N: 'K', NE: 'KD', E: 'D', SE: 'GD', S: 'G', SW: 'GB', W: 'B', NW: 'KB' },
    uv: 'Güneş gücü',
    uvLevels: {
        low: 'düşük',
        moderate: 'orta',
        high: 'yüksek',
        very_high: 'çok yüksek',
        extreme: 'aşırı',
    },
    uvValue: 'UV {value}, {level}',
    uvClearSky: 'açık havada',
    sun: 'Güneş',
    sunrise: 'Doğuş {time}',
    sunset: 'Batış {time}',
    course: 'Gün boyunca',
    courseOpen: 'Saat saat',
    back: 'Geri',
    courseTemp: 'Sıcaklık (°C)',
    courseRain: 'Yağış (saatte mm)',
    courseHour: '{time}: {temp}°, {rain} mm, rüzgâr kuvveti {bft}',
    partial: 'Bu günün tüm saatleri henüz bilinmiyor.',
    now: 'Şimdi',
    close: 'Kapat',
    symbols: {
        clear: 'güneşli',
        partly_cloudy: 'parçalı bulutlu',
        cloudy: 'bulutlu',
        fog: 'sisli',
        drizzle: 'çisenti',
        rain: 'yağmur',
        heavy_rain: 'şiddetli yağmur',
        sleet: 'sulu kar',
        snow: 'kar',
        thunder: 'gök gürültülü',
    },
};
//# sourceMappingURL=homeApp.tr.js.map